import { API_BASE_URL_ENV } from "../../jsx/common/common";
import BaseService from "../BaseService";

const apiEndpoint = API_BASE_URL_ENV() + "/work-shifts";

export default class WorkShiftService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
}
